import { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { SerializedError } from "@reduxjs/toolkit";

export function getErrorMessage(
  error: FetchBaseQueryError | SerializedError | undefined,
  fallbackMessage = "An error occurred",
): string | undefined {
  if (!error) return undefined;

  // Handle FetchBaseQueryError
  if ("status" in error && "data" in error) {
    return typeof error.data === "object" &&
      error.data &&
      "message" in error.data
      ? String(error.data.message)
      : fallbackMessage;
  }

  // Handle SerializedError
  if ("message" in error) {
    return error.message;
  }

  return fallbackMessage;
}
